
function SdInputSearchController(TranslationService) {
    var ctrl = this;
    
    ctrl.translation = TranslationService.getActiveTranslation();

    ctrl.search = function () {
        setTimeout(ctrl.onSearch);
    }

    ctrl.clear = function () {
        ctrl.filterString = '';
        ctrl.search();
    };

    //ctrl.$onInit = function () {
    //    console.log('$onInit');
    //};

    //ctrl.$onChanges = function () {
    //    ctrl.placeholder = ctrl.translation.Search;
    //    console.log('SdInputSearchController ' + ctrl.placeholder);
    //};
}

SdInputSearchController.$inject = ['TranslationService'];

seedWebApp.component('sdInputSearch', {
    controller: SdInputSearchController,
    bindings: {
        placeholder: '<',
        filterString: '=',
        onSearch: '<',
    },
    templateUrl: '/SPA/components/sd-input-search.html' + seedWebApp.buildVersion
});